export const RATING_SCALE = 5;

export const WHITE_COLOR = '#FFFFFF';
export const YELLOW_COLOR = '#FFCC00';
